import { Role } from './entitlements/role';
import { Individual } from './individual';
import { Organization } from './organization';
import { User } from './user';
import { UserSearchForm } from './user-search-form';

export class UserIndividual {
  user: User;
  individual: Individual;
  organizations: Organization[];

  static getInstance(userSearchForm: UserSearchForm) {
    const userIndividual: UserIndividual = new UserIndividual();

    userIndividual.user = new User();
    userIndividual.organizations = userSearchForm.organizations;
    userIndividual.user.userName = userSearchForm.userName;
    userIndividual.user.firstName = userSearchForm.firstName;
    userIndividual.user.lastName = userSearchForm.lastName;

    userIndividual.individual = new Individual();
    userIndividual.individual.individualId = userSearchForm.individualId;

    userIndividual.user.role = new Role();
    userIndividual.user.role.roleId = userSearchForm.roleId;

    return userIndividual;
  }
}
